<template>
    <div class="enrollment">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-presentation has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold">
                                <i class="fad fa-presentation has-text-primary is-hidden-desktop mr-2"></i>
                                {{ conference.title }}
                            </div>
                            <div class="meta">{{ conference.provider }}</div>
                            <div class="meta">{{ confDates }}</div>
                            <div v-if="!registrationOpen" class="mt-2 has-text-warning is-size-7"><i class="far fa-ban mr-2"></i>Registration Closed</div>
                        </div>
                        <div class="column has-text-right is-narrow">
                            <div>
                                <router-link :to="'/conference-center/register/' + conference.id">
                                    <b-button type="is-primary" size="" expanded :disabled="!registrationOpen"><i class="fas fa-arrow-right mr-2"></i>Register</b-button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details">

        </div>

    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Conference",
        props: {
            conference: {
                required: true
            }
        },
        computed: {
            confDates: function() {
                let s = moment(this.conference.start_at);
                let e = moment(this.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            regDates: function() {
                let s = moment(this.conference.open_at);
                let e = moment(this.conference.close_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            registrationOpen: function() {
                return moment().isBetween(this.conference.open_at, this.conference.close_at);
            }
        }

    };
</script>

<style lang="scss" scoped>
    .enrollment {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .meta {
            font-weight: normal;
            font-size: 0.8rem;
            color: #666d7a;
        }

    }
</style>

<style lang="scss">

    .enroll-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
